import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// TODO Review use of this class by reading https://lets-do-this.atlassian.net/browse/LDS-42
import { GLOBAL_FORM_STYLES_CLASS } from '@/globalClasses';

import ThumbnailGallery from '../ThumbnailGallery';
import CircleXIcon from '../Icons/CircleX';
import PhotoIcon, { Color } from '../Icons/Photo';

import Style from './styles.module.css';

export const VALID_FILE_TYPES = ['image/png', 'image/jpeg'].join(', ');

const imageInputId = 'imageinput';

const ImageInput = (props) => {
  const {
    className,
    onImageUpload,
    onThumbnailClick,
    images,
    onImageUploadInputClick,
    placeholder,
    multiple,
    discriminator,
    imageObjectFit,
  } = props;
  const id = `${imageInputId}${discriminator}`;

  const containerClassName = classNames(Style.container, className);
  // If images is present, show the images instead of the input form.
  if (images && images.length) {
    return (
      <div className={containerClassName} data-testing-id="image-input-gallery">
        <ThumbnailGallery
          images={images}
          onThumbnailClick={onThumbnailClick}
          renderIcon={CircleXIcon}
          imageObjectFit={imageObjectFit}
        />
      </div>
    );
  }
  return (
    <div
      className={classNames(
        containerClassName,
        Style.center,
        GLOBAL_FORM_STYLES_CLASS,
      )}
    >
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={Style.imageLabel} htmlFor={id} />
      <PhotoIcon className={Style.photoIcon} color={Color.GREY} />
      <input
        className={Style.imageInput}
        id={id}
        type="file"
        multiple={multiple}
        accept={VALID_FILE_TYPES}
        onClick={onImageUploadInputClick}
        onChange={onImageUpload}
      />
      <div className={Style.label}>{placeholder}</div>
    </div>
  );
};

ImageInput.propTypes = {
  // Urls or base64 encoded images to display thumbnails.
  images: PropTypes.arrayOf(PropTypes.string),
  // Function called with browser event when files are selected to be uploaded.
  onImageUpload: PropTypes.func,
  // Callback function for when the image input is clicked.
  onImageUploadInputClick: PropTypes.func,
  // Callback function for when a thumbnail is clicked. Passed a single integer argument of
  // index of the thumbnail that was clicked.
  onThumbnailClick: PropTypes.func,
  // Placeholder text
  placeholder: PropTypes.string,
  // Whether you accept multiple images or not.
  multiple: PropTypes.bool,
  // Optional suffix to prevent input elements having the same id.
  discriminator: PropTypes.string,
  // Optional change how images appear in thumbnail, defaults to cover
  imageObjectFit: PropTypes.string,
};

ImageInput.defaultProps = {
  images: [],
  onImageUpload: () => {},
  onImageUploadInputClick: () => {},
  onThumbnailClick: () => {},
  placeholder: 'Click to select photos.',
  multiple: true,
  discriminator: '',
  imageObjectFit: 'cover',
};

export default ImageInput;
